import { FILTER_DATE_TO } from './constants'

const initialState = {
  date: '',
  event: null,
}

export const getFilterDateTo = (state = initialState, action) => {
  switch (action.type) {
    case FILTER_DATE_TO:
      return {
        ...state,
        date: action.date,
        event: action.event,
      }
    default:
      return state
  }
}
